// extracted by mini-css-extract-plugin
export default {"sidebar":"SidebarAdmin_sidebar__QatWc","sidebar--mobile":"SidebarAdmin_sidebar--mobile__zEpqR"};